import { ReactNode } from "react";
import { createContext } from "../../lib/react";

type HeaderDropdownContextType = {
	openOnHover: boolean;
	onOpen: () => void;
	onClose: () => void;
};

const [HeaderDropdownContext, useHeaderDropdownContext] =
	createContext<HeaderDropdownContextType>("HeaderDropdown");

export { useHeaderDropdownContext };

export const HeaderDropdownContextProvider: React.FC<{
	value: HeaderDropdownContextType;
	children: ReactNode;
}> = ({ value, children }) => (
	<HeaderDropdownContext.Provider value={value}>
		{children}
	</HeaderDropdownContext.Provider>
);

// 🔬 TBD: Please evaluate
